export const list = {
  table: {
    tankNo: '洗剤No',
    detergentName: '洗剤名',
    method: '洗剤投入方法',
    netWeightMl: '1ケース内容量/ml',
    thresholdQuantity: 'アラート内容量/ml',
    remainingQuantity: '残量/ml',
    usedQuantity: '総使用量/ml',
    manual: '手動',
    automatic: '自動',
  },
  buttonAction: {
    importAdd: 'インポート（追加）',
    importOverwrite: 'インポート（上書き）',
    export: 'エクスポート',
    update: 'アップデート',
  },
  pageHeader: {
    title: '洗剤タンクリスト　TOP',
    titleDetergentsList: '個人データ登録/編集',
    new: '新規',
  },
}
